// extracted by mini-css-extract-plugin
module.exports = {"Display":"Display_Display__25T7h","Formula":"Display_Formula__JKtAm","Output":"Display_Output__58x--"};